module.exports = __webpack_public_path__ + "check-owners@2x.362d41ce26f9c45276b54250705c884d.png";